import React from 'react';
import Home from './screens/home';
import Ambassadors from './screens/ambassadors';
import Privacy from './screens/privacy';
import TimeSobr from './screens/teamsobr';
import Homeusa from './screens-usa/home';
import Ambassadorsusa from './screens-usa/ambassadors';
import Privacyusa from './screens-usa/privacy';
import TeamSobrusa from './screens-usa/teamsobr';
import Homees from './screens-es/home';
import Ambassadorses from './screens-es/ambassadors';
import Privacyes from './screens-es/privacy';
import TeamSobres from './screens-es/teamsobr';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useState, useEffect } from 'react';
import IndexDsk from './screens/homedsk/indexdsk.js';
import Ambassadorsdsk from './screens/ambassadorsdsk/indexdsk.js'; // Importe a primeira página desktop
import TimeSobrdsk from './screens/teamsobrdsk/indexdsk.js'; // Importe a segunda página desktop
import Privacydsk from './screens/privacydsk/indexdsk.js';
import IndexDskusa from './screens-usa/homedsk/indexdsk.js';
import Ambassadorsusadsk from './screens-usa/ambassadorsdsk/indexdsk.js'; // Importe a primeira página desktop
import TeamSobrusadsk from './screens-usa/teamsobrdsk/indexdsk.js'; // Importe a segunda página desktop
import Privacyusadsk from './screens-usa/privacydsk/indexdsk.js';
import IndexDskes from './screens-es/homedsk/indexdsk.js';
import Ambassadorsesdsk from './screens-es/ambassadorsdsk/indexdsk.js'; // Importe a primeira página desktop
import TeamSobresdsk from './screens-es/teamsobrdsk/indexdsk.js'; // Importe a segunda página desktop
import Privacyesdsk from './screens-es/privacydsk/indexdsk.js';

function App() {

    
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 768);
        };

        // Adiciona o event listener para escutar as mudanças no tamanho da tela
        window.addEventListener('resize', handleResize);

        // Limpa o event listener quando o componente é desmontado
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            {isDesktop ? (
                <BrowserRouter>
                    <Routes>
                        <Route path='/timesobr' element={<TimeSobrdsk />} />
                        <Route path='/embaixadores' element={<Ambassadorsdsk />} />
                        <Route path='/br' element={<IndexDsk />} />
                        <Route path='/termosepolitica' element={<Privacydsk />} />
                        <Route path='/teamsobr' element={<TeamSobrusadsk />} />
                        <Route path='/ambassadors' element={<Ambassadorsusadsk />} />
                        <Route path='/terms&policy' element={<Privacyusadsk />} />
                        <Route path='/' element={<IndexDskusa />} />
                        <Route path='/terminosypolitica' element={<Privacyesdsk />} />
                        <Route path='/equiposobr' element={<TeamSobresdsk />} />
                        <Route path='/embajadores' element={<Ambassadorsesdsk />} />
                        <Route path='/es' element={<IndexDskes />} />
                    </Routes>
                </BrowserRouter>
            ) : (
                <BrowserRouter>
                    <Routes>
                        <Route path='/embaixadores' element={<Ambassadors />} />
                        <Route path='/br' element={<Home />} />
                        <Route path='/timesobr' element={<TimeSobr />} />
                        <Route path='/termosepolitica' element={<Privacy />} />
                        <Route path='/ambassadors' element={<Ambassadorsusa />} />
                        <Route path='/' element={<Homeusa />} />
                        <Route path='/teamsobr' element={<TeamSobrusa />} />
                        <Route path='/terms&policy' element={<Privacyusa />} />  
                        <Route path='/embajadores' element={<Ambassadorses />} />
                        <Route path='/es' element={<Homees />} />
                        <Route path='/equiposobr' element={<TeamSobres />} />
                        <Route path='/terminosypolitica' element={<Privacyes />} />                       
                    </Routes>
                </BrowserRouter>
            )}
        </>
    );
}
export default App;
